import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  summary: css`
    width: 100%;
    padding-top: ${theme.spacing(2)}px;
    padding-bottom: ${theme.spacing(2)}px;
    border: 0;
    outline: 0;
    background-color: transparent;
    cursor: pointer;
    user-select: none;
    overflow: hidden;
    text-align: start;
    color: ${theme.go.schemes.colors.system.TextMain};
    transition: background-color 500ms ease-in-out;
  `,
  summaryExpanded: css`
    border-bottom: 1px solid ${theme.go.schemes.colors.system.Divider};
  `,
  expandIcon: css`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    transform: rotate(0deg);
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  `,
  iconExpanded: css`
    transform: rotate(180deg);
  `,
  details: css`
    width: 100%;
    height: 0;
    overflow: hidden;
  `,
  detailsExpanded: css`
    height: auto;
  `,
}
